export const getQueryParam = (param) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(param);
};

// Get cookie value
export const getCookie = (name) => {
  const cookies = document.cookie.split(';');

  for (let cookie of cookies) {
    cookie = cookie.trim();

    if (cookie.startsWith(name + '=')) {
      return cookie.substring(name.length + 1);
    }
  }

  return '';
};

// Extract CID from _ga cookie
export const getCID = () => {
  const ga = getCookie('_ga');

  if (!ga) return '';

  const parts = ga.split('.');

  if (parts.length >= 4) {
    return parts[2] + '.' + parts[3];
  }

  return '';
};

// Extract GCLID from _ga cookie
export const getGclidCookie = () => {
  const ga = getCookie('_ga');

  if (!ga) return '';

  const parts = ga.split('.');

  return parts.length >= 3 ? parts[2] : '';
};

// Extract GSessionID from _ga cookie
export const getGsessionIdCookie = () => {
  const ga = getCookie('_ga');

  if (!ga) return '';

  const parts = ga.split('.');

  return parts.length >= 4 ? parts[3] : '';
};

// Device Type same as jQuery
export const getDeviceType = () => {
  const ua = navigator.userAgent;

  const start = ua.indexOf('(') + 1;
  const end = ua.indexOf(')');

  if (start > 0 && end > start) {
    return ua.substring(start, end);
  }

  return ua;
};

// Get full tracking data (best practice)
export const getTrackingData = () => {
  let gclid = getQueryParam('gclid');
  let gsessionid = getQueryParam('gsessionid');

  if (!gclid) {
    gclid = getGclidCookie();
  }

  if (!gsessionid) {
    gsessionid = getGsessionIdCookie();
  }

  return {
    GCLID: gclid,
    GSessionID: gsessionid,
    CID: getCID(),
    DeviceType: getDeviceType(),
  };
};
